"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteManifest = void 0;
const useSiteCirrusStore_1 = require("./useSiteCirrusStore");
function useSiteManifest() {
    return useSiteCirrusStore_1.useSiteCirrusStore('/model/manifest.json');
}
exports.useSiteManifest = useSiteManifest;
//# sourceMappingURL=useSiteManifest.js.map